import { cn } from '@/lib/utils';

export interface Metric {
	label: string;
	value: number | string;
	dotClass: string;
	toneClass?: string;
	hint?: string;
}

export function MetricCards({ metrics }: { metrics: Metric[] }) {
	return (
		<div className="grid grid-cols-2 md:grid-cols-4 gap-2.5 px-4 md:px-5 pt-4">
			{metrics.map((m) => (
				<div key={m.label} className={cn('border border-line rounded-lg px-3.5 py-3 border-t-[3px]', m.toneClass)}>
					<div className="flex items-center gap-1.5 text-[15px] font-semibold text-ink-2 mb-1">
						<span className={cn('w-2 h-2 rounded-full', m.dotClass)} />
						{m.label}
					</div>
					<div className="text-[24px] font-semibold tracking-tight tabular text-ink">{m.value}</div>
					{m.hint ? <div className="text-[13px] text-ink-3 mt-0.5">{m.hint}</div> : null}
				</div>
			))}
		</div>
	);
}
